interface UndoIconProps {
  size?: number;
  className?: string;
}

/** Counter-clockwise arrow — "undo the last bulk action". */
const UndoIcon: React.FC<UndoIconProps> = ({ size = 14, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
    aria-hidden="true"
  >
    <path d="M3 8a5 5 0 1 1 1.5 3.6" />
    <path d="M3 4.5V8h3.5" />
  </svg>
);

export default UndoIcon;
